<template>
    <div class="inviteCode">
        <div class="content">
            <Header title="邀请码" :show-back="true" color="white"/>
            <div class="ercodeImg" ref="qrcode" id="ercodeImg"></div>
            <h2 class="code">我的邀请码：{{userInfo.promoter_no}}</h2>
            <p id="target" style="opacity: 0">{{url}}</p>
            <button
                    class="tagRead"
                    @click="copyEvent"
                    data-clipboard-action="copy"
                    data-clipboard-target="#target">
                复制推广链接
            </button>
        </div>
    </div>
</template>

<script>
    import QRCode from "qrcodejs2";
    import Clipboard from "clipboard";
    import Header from "../../components/header";
    import {mapState} from "vuex"

    export default {
        components: {
            Header
        },
        data() {
            return {
                url: ""
            };
        },
        computed: {
            ...mapState(["userInfo"])
        },
        mounted() {
            this.qrcode();
            console.log(this.userInfo);
        },
        methods: {
            qrcode() {
                let host = window.location.host;
                console.log("host", host);
                this.url = `https://${host}/#/register?code=${this.userInfo.promoter_no}`;
                this.$refs.qrcode.innerHTML = "";
                let qrcode = new QRCode("ercodeImg", {
                    errorCorrectionLevel: "H",
                    width: 100,
                    height: 100,
                    text: this.url, // 二维码内容
                });
                console.log(qrcode, this.url);
            },
            /*复制功能*/
            copyEvent() {
                let clipboard = new Clipboard(".tagRead");
                clipboard.on("success", (e) => {
                    this.$toast('复制成功');
                    e.clearSelection();
                });
                clipboard.on("error", (e) => {
                    // 不支持复制
                    this.$toast("暂不支持复制功能");
                    e.clearSelection();
                });
            },
        }
    };
</script>


<style lang="scss">
    .inviteCode {
        height: 100vh;

        .content {
            height: 100vh;
            background: url(../../assets/img/invite_bg.jpg) no-repeat 0 0;
            background-size: 100%;
            width: 100%;
        }

        .ercodeImg {
            padding: 13px;
            margin: 657px 197px 30px;
            background: transparent;

            img {
                display: inline-block;
                width: 195px;
                height: 195px;
                margin: 0 auto;
                padding: 10px;
                background: #fff;
            }
        }

        .code {
            font-size: 36px;
            color: #fff;
            line-height: 80px;
            text-align: center;
        }

        .tagRead {
            width: 356px;
            height: 86px;
            border-radius: 50px;
            margin: 0 197px;
            text-align: center;
            font-size: 30px;
            font-weight: bold;
            color: #fff;
            line-height: 86px;
            border: 2px solid #fff;
        }
    }
</style>
